import { Button, Container, Group, Text } from '@mantine/core';
import 'animate.css';
import classes from './Celebration.module.css';
import { Description, Emoji, Message, Wrapper } from './Celebration.style';

export type CelebrationProps = {
  type: CelebrationType;
  onNavigate: (path: string) => void;
};

export function Celebration(props: CelebrationProps) {
  return (
    <Wrapper
      className='Celebration-wrapper animate__animated animate__fadeInUp'
      data-testid='Celebration-wrapper'
    >
      <Container
        size={700}
        className={`${classes.inner} animate__animated animate__fadeIn animate__delay-1s`}
      >
        <h1 className={`${classes.title} animate__animated animate__zoomIn animate__delay-1s`}>
          <Emoji className='animate__animated animate__bounce animate__delay-3s'>🎉</Emoji>
          <Message>You have successfully purchased the plan</Message>
          Welcome to
          <br /> the{' '}
          <Text
            component='span'
            variant='gradient'
            gradient={{ from: 'pink', to: 'yellow' }}
            inherit
          >
            Plus Plan
          </Text>{' '}
        </h1>

        <Description className='animate__animated animate__fadeIn animate__delay-2s'>
          Unlock the full power of our platform with <b>unlimited projects</b>,{' '}
          <b>exclusive features</b>, and <b>priority support</b>. You're now set up for success!
        </Description>

        <Group
          className={`${classes.controls} animate__animated animate__fadeIn animate__delay-3s`}
        >
          <Button
            size='xl'
            className={classes.control}
            variant='gradient'
            gradient={{ from: 'pink', to: 'yellow' }}
            onClick={() => props.onNavigate('/generators')}
          >
            Explore Generators
          </Button>

          <Button
            component='a'
            size='xl'
            variant='default'
            className={classes.control}
            onClick={() => props.onNavigate('/projects')}
          >
            Go to My Projects
          </Button>
        </Group>
      </Container>
    </Wrapper>
  );
}

export default Celebration;
